import React, { Component } from "react";
import classes from "./EditJobProfile.module.css";
import MultiSelect from "../../commonComponents/MultiSelect";
import { connect } from "react-redux";
import Select from "react-select";
// import Loader from 'react-loader-advanced';
// import Spinner from 'react-bootstrap/Spinner'
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  Overlay,
  Tooltip,
} from "react-bootstrap";
import * as actionTypes from "../../../Action/Index";
// import ConfirmSweetAlert from '../../commonComponents/ConfirmSweetAlert'
// import SweetAlert from '../../commonComponents/SweetAlert'

class EditJobProfile extends Component {
  state = {
    min: 0,
    max: 30,
    mustHaveJobSkills: [],
    otherMustHaveSkills: [],
    otherPreferredSkills: [],
    preferredJobSkills: [],
    skillsRequired: false,
    confirmModalStatus: false,
    sweetAlertModal: false,
    titleErrorMsg: "",
    skillsErrorMsg: "",
    finalSkills: "",
    commonArray: [],
    file: "",
  };

  // sweetAlertModalHandler =(boolean)=>{
  //     this.setState({
  //         sweetAlertModal : boolean
  //     })
  // }

  // confirmModalHandler = (e)=>{
  //     e.preventDefault()
  //     this.setState({confirmModalStatus:true})
  // }
  myfun = () => {
    if (
      this.state.mustHaveJobSkills != undefined &&
      this.props.skillList != undefined
    ) {
      setTimeout(() => {
        let res = [];
        res = this.props.skillList.filter(
          (f) => !this.state.mustHaveJobSkills.includes(f.id)
        );
        this.setState({
          finalSkills: res,
        });
      }, 2000);
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (e.target.jobTitle.value === "") {
      this.setState({
        titleErrorMsg: "Enter a Job title",
        skillsErrorMsg: "",
      });
    } else if (!/^[A-Za-z+/ *_$@# 0-9.-]+$/i.test(e.target.jobTitle.value)) {
      this.setState({
        titleErrorMsg: "Please enter a valid Job title",
        skillsErrorMsg: "",
      });
    } else if (
      this.state.mustHaveJobSkills.length === 0 &&
      this.state.otherMustHaveSkills.length === 0
    ) {
      this.setState({
        skillsRequired: true,
        skillsErrorMsg: "Enter at least one skill",
        titleErrorMsg: "",
      });
    } else {
      const formData = new FormData();
      formData.append("file", this.state.cv);
      formData.append(
        "jsonData",
        new Blob(
          [
            JSON.stringify({
              jobTitle: e.target.jobTitle.value,
              //"clientName":e.target.clientname.value,
              id: this.props.jobId,
              maxExperience: this.state.max,
              minExperience: this.state.min,
              mustHaveSkill: this.state.mustHaveJobSkills,
              mustHaveSkillOthers: this.state.otherMustHaveSkills,
              prefferedSkill: this.state.preferredJobSkills,
              prefferedSkillOthers: this.state.otherPreferredSkills,
              allSkills: [
                ...this.state.mustHaveJobSkills,
                ...this.state.otherMustHaveSkills,
              ],
            }),
          ],
          {
            type: "application/json",
          }
        )
      );
      // const data = {
      //     //"id": this.props.viewSingleData != undefined ? this.props.viewSingleData.id : "",
      //     "jobTitle": e.target.jobTitle.value,
      //     //"clientName":e.target.clientname.value,
      //     "maxExperience": this.state.max,
      //     "minExperience": this.state.min,
      //     "mustHaveSkill": this.state.mustHaveJobSkills,
      //     "mustHaveSkillOthers": this.state.otherMustHaveSkills,
      //     "prefferedSkill": this.state.preferredJobSkills,
      //     "prefferedSkillOthers": this.state.otherPreferredSkills,
      //     "allSkills": this.state.commonArray,
      // }

      // console.log('job', {
      //     "jobTitle": e.target.jobTitle.value,
      //     //"clientName":e.target.clientname.value,
      //     "id": this.props.jobId,
      //     "maxExperience": this.state.max,
      //     "minExperience": this.state.min,
      //     "mustHaveSkill": this.state.mustHaveJobSkills,
      //     "mustHaveSkillOthers": this.state.otherMustHaveSkills,
      //     "prefferedSkill": this.state.preferredJobSkills,
      //     "prefferedSkillOthers": this.state.otherPreferredSkills,
      //     "allSkills": [...this.state.mustHaveJobSkills, ...this.state.otherMustHaveSkills],
      //    })

      this.props.updateJobProfile(formData, this.props.page);
      this.props.onHide();
      this.unshowResume();
      this.props.createsweetAlertModalHandler(true);
    }
  };

  mustHaveSkills = (values) => {
    if (values !== null && values.length === 1) {
      this.setState({
        skillsRequired: false,
        skillsErrorMsg: "",
      });
    }
    let arr_1 = [];
    let arr_2 = [];
    let commonArr = [];
    return values !== null
      ? values.map((value) => {
          if (value.__isNew__) {
            arr_2.push(value.value.trim());
            commonArr.push(value.value.trim());
          } else {
            arr_1.push(value.id);
            commonArr.push(value.id);
          }
          this.setState({
            mustHaveJobSkills: arr_1,
            otherMustHaveSkills: arr_2,
            commonArray: commonArr,
          });
        })
      : this.setState({
          mustHaveJobSkills: [],
          otherMustHaveSkills: [],
        });
  };

  componentWillReceiveProps(nextProps) {
    if (Object.keys(nextProps.viewSingleData).length !== 0) {
      this.setState({
        max: nextProps.viewSingleData.maxExperience,
        min: nextProps.viewSingleData.minExperience,
      });
    }
  }

  defaultValueFunction = () => {
    var allJobSkillsWithPreecedence = [];

    if (
      this.props.viewSingleData !== undefined &&
      this.props.viewSingleData.length != 0
    ) {
      if (this.props.viewSingleData.allJobSkillsWithPreecedence !== undefined) {
        allJobSkillsWithPreecedence = this.props.viewSingleData.allJobSkillsWithPreecedence.map(
          (el) => el
        );
      }
    }
    var commonArray = allJobSkillsWithPreecedence;
    return commonArray;
  };

  getSkillListHandler = () => {
    var mustHaveJobSkills = [];
    var otherMustHaveSkills = [];
    var preferredJobSkills = [];
    var otherPreferredSkills = [];
    if (
      this.props.viewSingleData !== undefined &&
      this.props.viewSingleData.length != 0
    ) {
      if (this.props.viewSingleData.mustHaveJobSkills !== undefined) {
        mustHaveJobSkills = this.props.viewSingleData.mustHaveJobSkills.map(
          (el) => el
        );
        const newMustHaveJobSkills = mustHaveJobSkills.map((element) => {
          return element.id;
        });
        this.setState({ mustHaveJobSkills: newMustHaveJobSkills });
      }
      if (this.props.viewSingleData.otherMustHaveSkills !== undefined) {
        otherMustHaveSkills = this.props.viewSingleData.otherMustHaveSkills.map(
          (el) => el
        );
        const newotherMustHaveSkills = this.props.viewSingleData.otherMustHaveSkills.map(
          (element) => {
            return element.value;
          }
        );
        this.setState({ otherMustHaveSkills: newotherMustHaveSkills });
      }
      if (this.props.viewSingleData.preferredJobSkills !== undefined) {
        preferredJobSkills = this.props.viewSingleData.otherMustHaveSkills.map(
          (el) => el
        );
        const newpreferredJobSkills = this.props.viewSingleData.preferredJobSkills.map(
          (element) => {
            return element.id;
          }
        );
        this.setState({ preferredJobSkills: newpreferredJobSkills });
      }
      if (this.props.viewSingleData.otherPreferredSkills !== undefined) {
        otherPreferredSkills = this.props.viewSingleData.otherPreferredSkills.map(
          (el) => el
        );
        const newotherPreferredSkills = this.props.viewSingleData.otherPreferredSkills.map(
          (element) => {
            return element.value;
          }
        );
        this.setState({ otherPreferredSkills: newotherPreferredSkills });
      }
    }
    //  this.props.getSkillsList()
    this.props.createsweetAlertModalHandler(false);
  };

  showResume = (event) => {
    event.preventDefault();
    if (event.target.files[0] !== undefined) {
      const myfile = event.target.files[0].name;
      var ext = myfile.split(".").pop();
      var FileSize = event.target.files[0].size / 1024 / 1024;
    }
    if (event.target.files[0] !== undefined) {
      if ((ext == "pdf" || ext == "doc" || ext == "docx") && FileSize <= 3) {
        this.setState({
          file: event.target.files[0].name,
          cv: event.target.files[0],
          invalidFormat: false,
          fileRequired: false,
          skillsRequired: false,
        });
      } else {
        document.getElementById("upload").value = null;
        this.setState({
          file: "",
          invalidFormat: true,
          fileRequired: false,
          skillsRequired: false,
        });
      }
    }
  };

  unshowResume = () => {
    this.setState({
      file: "",
      invalidFormat: false,
      fileRequired: false,
      skillsRequired: false,
      uploadFreshResume: false,
    });
    //document.getElementsByName('file')[0].value = null;
  };

  render() {
    console.log("test", this.state.file);
    let minOptions = [];
    for (let i = 0; i < Number(this.state.max); i++) {
      if (i === 0) {
        minOptions.push({ value: i, label: `${i}` });
      } else if (i === 1) {
        minOptions.push({ value: i, label: `${i} year` });
      } else {
        minOptions.push({ value: i, label: `${i} years` });
      }
    }
    let maxOptions = [];
    for (let i = Number(this.state.min) + 1; i <= 30; i++) {
      if (i === 0) {
        maxOptions.push({ value: i, label: `${i}` });
      } else if (i === 1) {
        maxOptions.push({ value: i, label: `${i} year` });
      } else {
        maxOptions.push({ value: i, label: `${i} years` });
      }
    }
    let monthsOptions = [];
    for (let i = 0; i <= 11; i++) {
      monthsOptions.push({ value: i, label: `${i}` });
    }
    return (
      <Modal
        dialogClassName={classes.createModal}
        {...this.props}
        size="lg"
        data-keyboard="false"
        backdrop="false"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onShow={() => {
          this.getSkillListHandler();
        }}
        // onEntered={() => { this.myfun() }}
      >
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={classes.Title}
        >
          Edit Profile
        </Modal.Title>
        <Modal.Body>
          <Form onSubmit={(e) => this.handleSubmit(e)}>
            <Form.Row className={classes.Row} style={{ marginBottom: "0px" }}>
              <Form.Label
                column
                lg={2}
                md={3}
                sm={4}
                xs={6}
                className={classes.InputFont}
              >
                Title:
              </Form.Label>
              <Col lg={10} md={8} sm={6} xs={10}>
                <Form.Control
                  type="text"
                  className={classes.Input}
                  tabIndex="1"
                  defaultValue={
                    this.props.viewSingleData != undefined
                      ? this.props.viewSingleData.jobTitle
                      : ""
                  }
                  style={{ width: "89%", marginLeft: "50px" }}
                  maxLength="37"
                  autoComplete="off"
                  onFocus={() => {
                    this.setState({ skillsErrorMsg: "" });
                  }}
                  onInput={() => this.setState({ titleErrorMsg: "" })}
                  id="job_input2"
                  name="jobTitle"
                />
                <span className={classes.ValidateTitle}>
                  &nbsp;{this.state.titleErrorMsg}
                </span>
              </Col>
            </Form.Row>

            {/* <Form.Row className={classes.Row} style = {{marginBottom: "0px"}}>
                            <Form.Label column lg={3} md={3} sm={4} xs={6} className={classes.InputFont}>
                            Client Name:<br/><span style={{fontSize:"14px"}}>(Optional)</span>
                            </Form.Label>
                            <Col lg={9} md={8} sm={6} xs={10}>
                                <Form.Control type="text" className={classes.Input} style={{ width: '99%', marginLeft: '5px' }}
                                    name="clientname"  tabIndex = "1"                                                                                                                       
                                   maxLength="37"  autoComplete = "off"
                                   defaultValue={this.props.viewSingleData != undefined ? this.props.viewSingleData.clientName : ""}
                                    id = "clientname"
                                    
                                    onFocus = {() => {this.setState({skillsErrorMsg: "", maxErrorMsg: ""})}}
                                    onInput = {() => this.setState({clientErrorMsg: ""})}/>
                                    <span className = {classes.ValidateTitle}>&nbsp;{this.state.clientErrorMsg}</span>
                            </Col>
                        </Form.Row> */}

            <Form.Row className={classes.Row}>
              <Form.Label
                column
                lg={3}
                md={5}
                className={classes.InputFont}
                style={{ paddingRight: "3px" }}
              >
                Experience:
              </Form.Label>

              <Col
                lg={3}
                md={3}
                onFocus={() => {
                  this.setState({ titleErrorMsg: "", skillsErrorMsg: "" });
                }}
              >
                <Select
                  //  value={{value:1,label:1}}
                  id="min"
                  name="min"
                  maxMenuHeight="140px"
                  defaultValue={
                    this.props.viewSingleData != undefined
                      ? {
                          value:
                            this.props.viewSingleData.minExperience <= 1
                              ? `${this.props.viewSingleData.minExperience}`
                              : `${this.props.viewSingleData.minExperience}`,
                          label:
                            this.props.viewSingleData.minExperience <= 1
                              ? `${this.props.viewSingleData.minExperience}`
                              : `${this.props.viewSingleData.minExperience}`,
                        }
                      : { value: "", label: "" }
                  }
                  onChange={(text) => {
                    console.log("");
                    this.setState({ min: text.value });
                  }}
                  options={monthsOptions}
                  styles={{
                    control: (base) => ({
                      ...base,
                      margin: "0",
                      color: "white",
                      border: "1px solid",
                      borderBottom: "1px solid lightgrey",
                      "&:hover": {
                        border: "1px solid !important",
                        borderBottom: "1px solid lightgrey !important",
                        borderRadius: "0",
                      },
                      "&:focus-within": {
                        borderBottom: "1px solid lightgrey !important",
                        boxShadow: "none !important",
                        outline: "none !important",
                        outlineWidth: "0 !important",
                      },
                    }),
                    container: (base) => ({
                      ...base,
                      position: "relative",
                      top: "-6.5px",
                      color: "black",
                      border: "none",
                    }),
                    clearIndicator: (base) => ({
                      ...base,
                      color: "black",
                      border: "none",
                    }),
                    indicatorSeparator: (base) => ({
                      ...base,
                      color: "blue",
                      display: "none",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      padding: "-50px",
                      position: "relative",
                      bottom: "-7px",
                      justifyContent: "center",
                    }),
                    placeholder: (base) => ({ ...base, display: "none" }),
                    singleValue: (base) => ({
                      ...base,
                      color: "black",
                      fontWeight: "900",
                    }),
                  }}
                />
                {/* <Form.Control as="select" className={classes.Input} name="min" required id = "min"
                                defaultValue={this.props.viewSingleData!=undefined ?this.props.viewSingleData.minExperience:""}
                                onChange = {(e) => this.setState({min: e.target.value })}
                                onFocus = {() => {this.setState({skillsErrorMsg: false})}}
                                onMouseEnter = {(e) =>{ this.setState({min: e.target.value, max:document.getElementById('max').value}); this.onMouseEnter = null;}}>
                                    {minOptions}
                                </Form.Control> */}
              </Col>
              <Form.Label
                column
                lg={1}
                md={1}
                className={classes.InputFont}
                style={{ textAlign: "right", marginLeft: "0px" }}
              >
                Years
              </Form.Label>

              <Col
                lg={3}
                md={3}
                onFocus={() => {
                  this.setState({ titleErrorMsg: "", skillsErrorMsg: "" });
                }}
              >
                <Select
                  id="max"
                  name="max"
                  //  value={{value:1,label:1}}
                  onFocus={() => {
                    this.setState({ skillsErrorMsg: "" });
                  }}
                  //onMouseEnter={(text) => { this.setState({ max: text.value, min: document.getElementById('min').value }); this.onMouseEnter = null; }}
                  defaultValue={
                    this.props.viewSingleData != undefined
                      ? {
                          value:
                            this.props.viewSingleData.maxExperience <= 1
                              ? `${this.props.viewSingleData.maxExperience}`
                              : `${this.props.viewSingleData.maxExperience}`,
                          label:
                            this.props.viewSingleData.maxExperience <= 1
                              ? `${this.props.viewSingleData.maxExperience}`
                              : `${this.props.viewSingleData.maxExperience}`,
                        }
                      : { value: "", label: "" }
                  }
                  maxMenuHeight="140px"
                  onChange={(text) => {
                    this.setState({ max: text.value });
                  }}
                  options={monthsOptions}
                  styles={{
                    control: (base) => ({
                      ...base,
                      margin: "0",
                      color: "white",
                      border: "1px solid",
                      borderBottom: "1px solid lightgrey",
                      "&:hover": {
                        border: "1px solid !important",
                        borderBottom: "1px solid lightgrey !important",
                        borderRadius: "0",
                      },
                      "&:focus-within": {
                        borderBottom: "1px solid lightgrey !important",
                        boxShadow: "none !important",
                        outline: "none !important",
                        outlineWidth: "0 !important",
                      },
                    }),
                    container: (base) => ({
                      ...base,
                      position: "relative",
                      top: "-11px",
                      color: "black",
                      border: "none",
                    }),
                    clearIndicator: (base) => ({
                      ...base,
                      color: "black",
                      border: "none",
                    }),
                    indicatorSeparator: (base) => ({
                      ...base,
                      color: "blue",
                      display: "none",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      padding: "-40px",
                      position: "relative",
                      bottom: "-10px",
                      justifyContent: "center",
                    }),
                    placeholder: (base) => ({ ...base, display: "none" }),
                    input: (base) => ({
                      ...base,
                      color: "black",
                      fontSize: "22px",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: "black",
                      fontWeight: "900",
                    }),
                  }}
                />
              </Col>
              <Form.Label
                column
                lg={1}
                md={1}
                className={classes.InputFont}
                style={{ textAlign: "right" }}
              >
                Months
              </Form.Label>
            </Form.Row>
            <Form.Row className={classes.Row}>
              <Form.Label className={classes.InputFont} column lg={3} md={7}>
                Skills:
              </Form.Label>
              <Col
                lg={9}
                onFocus={() => {
                  this.setState({ titleErrorMsg: "" });
                }}
              >
                <MultiSelect
                  options={this.props.skillList}
                  defaultValue={this.defaultValueFunction()}
                  skills={(values) => this.mustHaveSkills(values)}
                  tabNo="4"
                />
                <span className={classes.ValidateSkills}>
                  &nbsp;{this.state.skillsErrorMsg}
                </span>
              </Col>
            </Form.Row>

            {this.state.uploadFreshResume ? (
              <Row>
                {this.state.file !== "" ? (
                  <div className="col-md-5 sm-md-5 offset-4">
                    <i
                      class="fa fa-window-close"
                      aria-hidden="true"
                      style={{
                        float: "right",
                        margin: "0px 18px -14px 0px",
                        color: "#fbb03b",
                      }}
                      onClick={this.unshowResume}
                    ></i>
                  </div>
                ) : null}
                <label
                  htmlFor="upload"
                  className={` ${classes.IconStyle} ${classes.InputFileText}`}
                  style={{ marginBottom: "35px", outlineColor: "transparent" }}
                >
                  {this.state.file !== "" ? (
                    <p style={{ margin: 0 }}>{this.state.file}</p>
                  ) : (
                    <i
                      className="fa fa-fw fa-cloud-upload-alt"
                      style={{
                        color: "#fbb03b",
                        marginRight: "22px",
                        fontSize: "23px",
                      }}
                    />
                  )}
                  <input
                    id="upload"
                    type="file"
                    className={classes.File}
                    accept=".docx,.doc,.pdf"
                    name="file"
                    onInput={() =>
                      this.setState({
                        nameErrorMsg: "",
                        skillsErrorMsg: "",
                        mobileErrorMsg: "",
                        emailErrorMsg: "",
                        yearsErrorMsg: "",
                      })
                    }
                    onChange={(e) => this.showResume(e)}
                    tabIndex="7"
                  />
                  {this.state.file !== "" ? null : "Upload Resume"}
                </label>
              </Row>
            ) : (
              <Row>
                <div className="col-md-5 sm-md-5 offset-4">
                  <i
                    class="fa fa-window-close"
                    aria-hidden="true"
                    style={{
                      float: "right",
                      margin: "0px 18px -14px 0px",
                      color: "#fbb03b",
                    }}
                    onClick={() => {
                      this.setState({ uploadFreshResume: true });
                    }}
                  />
                </div>
                <label
                  className={` ${classes.IconStyleView} ${classes.InputFileText}`}
                  style={{ marginBottom: "35px", cursor: "default" }}
                >
                  <span>
                    <a
                      target="_blank"
                      href={this.props.candidate_cv_data}
                      className={classes.ViewCV}
                      onClick={() =>
                        this.setState({
                          nameErrorMsg: "",
                          skillsErrorMsg: "",
                          mobileErrorMsg: "",
                          emailErrorMsg: "",
                          yearsErrorMsg: "",
                        })
                      }
                    >
                      <p style={{ margin: 0, padding: "3px" }}>View Resume</p>
                    </a>
                  </span>
                </label>
              </Row>
            )}
            <Row>
              {this.state.invalidFormat ? (
                <div className={classes.InvalidFormat}>
                  *doc,pdf- Less than 3MB
                </div>
              ) : null}
              {this.state.fileRequired ? (
                <div className={classes.InvalidFormat}>
                  Uploading Resume is Mandatory
                </div>
              ) : null}
              {this.state.downloadError ? (
                <div className={classes.InvalidFormat}>
                  {this.state.downloadErrorMsg}
                </div>
              ) : null}
            </Row>

            <Row style={{ marginTop: "58px" }}>
              <Col lg={6}></Col>
              <Col lg={6} style={{ marginTop: "-10px", marginBottom: "-10px" }}>
                <Button
                  onClick={() => {
                    this.props.onHide();
                    this.setState({
                      min: 0,
                      max: 30,
                      skillsRequired: false,
                      titleErrorMsg: "",
                      skillsErrorMsg: "",
                    });
                  }}
                  tabIndex="6"
                  variant="outline-warning"
                  className={classes.Button_1}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  className={classes.Button_2}
                  variant="warning"
                  tabIndex="5"
                  onClick={() => {
                    this.setState({ titleErrorMsg: "", skillsErrorMsg: "" });
                  }}
                >
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    skillLoader: state.employeeReducer.skillLoader,
    skillList: state.employeeReducer.skillList,
    candidate_cv_data: state.employeeReducer.candidate_cv_data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateJobProfile: (data, page) =>
      dispatch(actionTypes.updateJobProfile(data, page)),
    getSkillsList: () => dispatch(actionTypes.getSkillsMaster()),
    //candidateDownloadFile: (id) => dispatch(actionTypes.candidateDownloadFile(id))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(EditJobProfile);
